export const choixSexe = [
    { key: 'F', value: 'F', libelle: 'Féminin' },
    { key: 'M', value: 'M', libelle: 'Masculin' },
];

export const NUMERO_FRANCE = '75';

export const typePieceIdentite = [
    { key: 'CNI', value: 2, libelle: "Carte nationale d'identité" },
    { key: 'passeport', value: 33, libelle: 'Passeport' },
    { key: 'titreSejour', value: 34, libelle: 'Titre de séjour' },
    { key: 'pieceIdentiteEtrangere', value: 35, libelle: 'Pièce identité étrangère' },
];
